import React, { memo, useEffect, useMemo, useState } from 'react'

// const Modes = () => {
// 	return (
// 		<div className=""></div>
// 	);
// }

class ModesOld extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isModesActive: true,
      showModes: false,
      isOpen: false,
      isClose: false,
    }
  }

  render() {
    let modes_class_value
    console.log(this.props)
    if (this.props.show_modes) {
      modes_class_value = 'modes-show ' + this.props.modes_class
    } else {
      modes_class_value = this.props.modes_class
    }
    return (
      <section id={this.props.modes_id} className={modes_class_value}>
        {/* <div>ajksdhcajebywgbygyj</div> */}
        {this.props.children}
      </section>
    )
  }
}


const Modes = ({ isOpen, children, modesId, modesClass }) => {
  // console.log(isOpen)
  const [modesStyle, setModesStyle] = useState('modes');

  useMemo(() => {
    // if (modesStyle !== !modesStyle) {
    if (isOpen) {
      setModesStyle('modes modes-show');
    } else {
      setModesStyle('modes');
    }
    // }
    return () => { }
  }, [isOpen, modesStyle]);
  // const closeModes = () => {
  //   setModesStyle('modes');
  //   onClose();
  // };
  // console.log(modesStyle)

  return (
    <section id={modesId} className={`${modesStyle}${" " + modesClass}`}>
      {children}
    </section>
  )
}
export default Modes;